import { render, staticRenderFns } from "./AttentionModal.vue?vue&type=template&id=eda993e8&scoped=true&"
import script from "./AttentionModal.vue?vue&type=script&lang=js&"
export * from "./AttentionModal.vue?vue&type=script&lang=js&"
import style0 from "./AttentionModal.vue?vue&type=style&index=0&id=eda993e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda993e8",
  null
  
)

export default component.exports